import React, { useEffect, useRef, useState } from 'react';
import { Typography } from 'antd';
import {
  BookOutlined,
  LaptopOutlined,
  DatabaseOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  LinkOutlined,
  RiseOutlined,
} from '@ant-design/icons';

import '../../../Styles/ResearchLabs.css';


const { Title } = Typography;


/* =========================================================
   COUNT UP
   ========================================================= */

const CountUp = ({ end, start, duration = 1800 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) return;

    let startTime = null;
    let animationFrame;

    const animate = (time) => {
      if (!startTime) startTime = time;

      const progress = Math.min(
        (time - startTime) / duration,
        1
      );

      setCount(Math.floor(progress * end));

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrame);
  }, [end, start, duration]);

  return <>{count}</>;
};


/* =========================================================
   IMPACT DATA
   ========================================================= */

const impactData = [
  {
    value: 8,
    title: 'Academic Research & Development',
    icon: BookOutlined,
  },
  {
    value: 4,
    title: 'Hardware/ Software',
    icon: LaptopOutlined,
  },
  {
    value: 116,
    title: 'Data & Inventory Management',
    icon: DatabaseOutlined,
  },
  {
    value: 82,
    title: 'Models & Maps Development',
    icon: EnvironmentOutlined,
  },
  {
    value: 45,
    title: 'Capacity Building',
    icon: TeamOutlined,
  },
  {
    value: 20,
    title: 'Linkages & Commercialization',
    icon: LinkOutlined,
  },
  {
    value: 4,
    title: 'Research Impact',
    icon: RiseOutlined,
  },
];


/* =========================================================
   IMPACT COMPONENT
   ========================================================= */

const Impact = () => {
  const sectionRef = useRef(null);
  const [startCounter, setStartCounter] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCounter(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.25,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="impact-section"
    >
      <div className="impact-overlay">

        <div className="impact-inner">

          {/* Heading */}
          <div className="impact-heading">
            <Title level={2}>Impact</Title>
            <div className="impact-heading-line" />
          </div>


          {/* Impact Cards */}
          <div className="impact-grid">

            {impactData.map(({ value, title, icon: Icon }) => (

              <div
                className="impact-card"
                key={title}
              >

                <div className="impact-card-icon">
                  <Icon />
                </div>

                <div className="impact-number">
                  <CountUp
                    end={value}
                    start={startCounter}
                  />
                </div>

                <div className="impact-card-title">
                  {title}
                </div>

              </div>

            ))}

          </div>

        </div>

      </div>
    </section>
  );
};

export default Impact;
